import { LevelProgressResponse } from "../../types/rewards";

export const getLevelProgressModel = (
  response: LevelProgressResponse
): LevelProgressResponse => response;
